var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgMerge = function SvgMerge(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Merge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.39961 21L5.34961 19.95L10.2496 15.05C10.6496 14.65 10.9163 14.2833 11.0496 13.95C11.1829 13.6167 11.2496 13.125 11.2496 12.475V5.85L8.99961 8.1L7.94961 7.05L11.9996 3L16.0496 7.05L14.9996 8.1L12.7496 5.85V12.475C12.7496 13.125 12.8163 13.6167 12.9496 13.95C13.0829 14.2833 13.3496 14.65 13.7496 15.05L18.6496 19.95L17.5996 21L11.9996 15.4L6.39961 21Z",
    fill: "currentColor"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgMerge);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/Merge.60c0994b3203c032d0c95a4057438d72.svg";